import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersEmployeeSurveysMutateResponseType,
  ApiManagersEmployeeSurveysMutateRequestType,
} from "~/domains";

type RequestDataType = {
  body: ApiManagersEmployeeSurveysMutateRequestType;
};

const request = ({ body }: RequestDataType) => {
  return new ApiClient()
    .post<ApiManagersEmployeeSurveysMutateResponseType>(
      "/api/managers/employee_surveys",
      {
        employeeSurvey: body,
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersEmployeeSurveysCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiManagersEmployeeSurveysMutateResponseType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
